module.exports = __webpack_public_path__ + "img/registerUser-blog.b994b590.png";